<div class="toolbox-component" id="layout">
  <div class="header">
    <div class="header-title">
      <span class="header-title-main">
        @if (isBoxStep) {
          {{ 'i18n.toolbox.layout.titleBox' | translate }}
        } @else {
          {{ 'i18n.toolbox.layout.title' | translate }}
        }
      </span>
    </div>
    <mat-icon svgIcon="close"
      class="close-x"
    (click)="btnCloseClick()"></mat-icon>
  </div>
  <template-chooser
    (selectedTemplateChange)="updateSelectedTemplate($event.templateGroupId, $event.templateId)"
  ></template-chooser>
</div>
